import axios from '@/config/axios.config';

const API_BASE_URL = '/api/student/transcript';

// Backend response types
export interface ComponentGrade {
  componentName: string;
  score: number | null;
  percentage: number;
  isFromRattrapage: boolean;
  absenceStatus: string;
}

export interface ElementGrade {
  elementId: string;
  elementName: string;
  elementCode: string | null;
  components: ComponentGrade[];
  average: number | null;
  status: 'finalized' | 'pending' | 'absent';
  isFromRattrapage: boolean;
  // Survey gating fields
  surveyRequired?: boolean;
  surveyCompleted?: boolean;
  cumulativeGradeWeight?: number;
  groupeId?: string;
  professorId?: string;
}

export interface ModuleGrade {
  moduleId: string;
  moduleName: string;
  moduleCode: string;
  coefficient: number;
  elements: ElementGrade[];
  average: number | null;
  status: 'finalized' | 'pending' | 'partial';
}

export interface SemesterData {
  semesterId: string;
  semesterNumber: number;
  semesterName: string;
  modules: ModuleGrade[];
  average: number | null;
  status: 'finalized' | 'pending' | 'partial';
}

export interface AcademicYearData {
  academicYearId: string;
  academicYearName: string;
  semesters: SemesterData[];
  annualAverage: number | null;
  mention: string | null;
}

export interface TranscriptData {
  student: {
    firstName: string;
    lastName: string;
    studentCode: string;
    filiere: string;
    filiereCode: string;
    campus: string;
  };
  academicYears: AcademicYearData[];
}

export const getStudentTranscript = async (): Promise<TranscriptData> => {
  const response = await axios.get(API_BASE_URL);
  return response.data;
};
